<script>
    import { preventDefault } from 'svelte/legacy';

    import { projectState } from "@app/store/projectStore.svelte.js";
    import { modalState, showModal, hideModal } from "@app/store/modalStore.svelte.js";
    import { markerState } from "@app/store/markerStore.svelte.js";
    import { toast } from "@zerodevx/svelte-toast";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { fade } from "svelte/transition";
    import tcLib from "@cclib/lib/timecode.js";
    import _Marker from "@cclib/classes/marker.js";
    import { v4 as uuidv4 } from "uuid";
    import * as m from "@app/paraglide/messages.js";
    let files = $state(),
        srcExt = "",
        srcFileName = "",
        fileContents = $state(""),
        markerGroup = $state("new"),
        offsetTimecode = $state(false),
        importOption = $state("replace"),
        markerGroupName = $state("Untitled");

    const hexColors = [
        "#ff66cc",
        "#00cc00",
        "#0066ff",
        "#6600ff",
        "#ff0066",
        "#6666ff",
        "#00cc99",
        "#99ccff",
        "#ff9966",
        "#ff33cc",
        "#009900",
        "#ff9933",
        "#009999",
        "#333399",
        "#999966",
        "#99ccff",
        "#990033",
        "#996600",
        "#ffcc99",
        "#6699ff",
    ];

    // Handler for file inputs
    function handleFileInput(event) {
        files = Array.from(event.currentTarget.files || []);
        updateFile();
    }

    function updateFile() {
        if (files[0] && files[0].name) {
            let fileName = files[0].name.split(".");
            srcExt = fileName.pop().toLowerCase();
            srcFileName = fileName.shift();
            updateFileContents();
        }
    }

    function updateFileContents() {
        if (files && files[0]) {
            toast.push(m.marker_import_reading_file_toast(), {
                classes: ["toast-warning"],
            });
            let reader = new FileReader();
            reader.onload = async function (e) {
                fileContents = e.target.result;
            };

            reader.readAsText(files[0], "utf-8");
        }
    }

    async function importMarkers() {
        try {
            let markers = [];
            if (srcExt === "json") {
                let markerData = JSON.parse(fileContents);
                markerData.forEach((marker) => {
                    try {
                        let newMarker = {...(new _Marker({
                            time: tcLib.parseTcToSec(
                                marker.time,
                                projectState.frameRate,
                                projectState.dropFrame,
                            ),
                            endTime: marker.endTime !== undefined ? tcLib.parseTcToSec(
                                marker.endTime,
                                projectState.frameRate,
                                projectState.dropFrame,
                            ) : false,
                            comment: marker.comment
                                ? marker.comment.toString()
                                : ""
                        }))};

                        markers.push(newMarker);
                    } catch (error) {
                        console.error("Error pushing marker:", error);
                    }
                });
            } else if (srcExt === "edl") {
                let edlData = parseEDL(fileContents);
                // console.log(edlData);
                edlData.clips.forEach((clip) => {
                    try {
                        markers.push(
                            {...(new _Marker({
                                time: tcLib.parseTcToSec(
                                    clip.sequence_in,
                                    projectState.frameRate,
                                    projectState.dropFrame,
                                ),
                                comment: clip.clip_id.toString(),
                            }))}
                        );
                    } catch (error) {
                        console.error("Error pushing marker:", error);
                    }

                    try {
                        markers.push(
                            {...(new _Marker({
                                time: tcLib.parseTcToSec(
                                    clip.sequence_out,
                                    projectState.frameRate,
                                    projectState.dropFrame,
                                ),
                                comment: clip.clip_id.toString(),
                            }))}
                        );
                    } catch (error) {
                        console.error("Error pushing marker:", error);
                    }
                });
            } else {
                toast.push(m.marker_import_invalid_format_toast(), {
                    classes: ["toast-error"],
                });
                hideModal();
                return;
            }

            //Filter markers to remove markers that have the same time. Only keep the first one.
            // console.log("MARKERS BEFORE FILTER", markers);
            markers = markers.filter((marker, index, self) => {
                return (
                    index ===
                    self.findIndex((m) => {
                        return (
                            parseFloat(m.time).toFixed(3) ===
                            parseFloat(marker.time).toFixed(3)
                        );
                    })
                );
            });

            if (offsetTimecode) {
                let offset = projectState.incode;
                markers = markers.map((marker) => {
                    return {
                        ...marker,
                        time: marker.time - offset,
                    };
                });
            }
            

            if (markerGroup === "new") {
                markerState.lists = [
                    ...markerState.lists,
                    {
                        id: uuidv4(),
                        name: markerGroupName,
                        color: hexColors[Math.floor(Math.random() * 20)],
                        markers: markers,
                    },
                ];

                markerState.selected = markerState.lists.length - 1;
            } else {
                let markerListIndex = markerState.lists.findIndex(
                    (markerList) => {
                        return markerList.id == markerGroup;
                    },
                );
                if (importOption === "replace") {
                    markerState.lists[markerListIndex] = {
                        ...markerState.lists[markerListIndex],
                        markers: markers,
                    }
                } else {
                    /* Merge markers */
                    markerState.lists[markerListIndex] = {
                        ...markerState.lists[markerListIndex],
                        markers: [
                            ...markerState.lists[markerListIndex].markers,
                            ...markers,
                        ]
                    };
                }
            }

            

            insertHistoryAction({
                name: "import markers", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "markerState",
                        value: JSON.stringify(markerState),
                    },
                ],
            });
        } catch (err) {
            console.error(err);
            console.log(err.message);
            toast.push(
                m.marker_import_error_toast({ error: err.message }),
                { classes: ["toast-error"] },
            );
        } finally {
            hideModal();
        }
    }

    function parseEDL(edlContent) {
        console.log("Paring EDL...");
        let result = {
            clips : []
        };

        let lines = edlContent.split("\n");
        let lastIndex = 0;
        lines.forEach(line =>{
            let lineContent = line.split(" ").filter(l => {return l});
            if (lineContent[0] && parseFloat(lineContent[0]) === lastIndex+1){
                // console.log(lineContent[0]);
                // console.log(lineContent[4]);
                result.clips.push({
                    clip_id: lineContent[0],
                    sequence_in: lineContent[4],
                    sequence_out: lineContent[5]
                });

                lastIndex++;
            }
        });

        console.log("Done parsing EDL", result);
        return result;
    }
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'markerImport' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="markerImportTitle"
    aria-describedby="markerImportDescription"
    tabindex="-1"
    id="MarkerImportModal"
>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="markerImportTitle">
                    {m.marker_import_title()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    id="closeMarkerImportBtn"
                    aria-label={m.marker_import_close_label()}
                    onclick={hideModal}
                ></button>
            </div>
            <div class="modal-body">
                <p id="markerImportDescription" class="sr-only">
                    {m.marker_import_description()}
                </p>
                <p class="small text-muted">
                    <i class="bi bi-lightning-fill" aria-hidden="true"></i> 
                    <span>{m.marker_import_powered_by()}</span>
                </p>

                <div class="row">
                    <div class="col">
                        <!-- Import Form Start -->
                        <form onsubmit={preventDefault(importMarkers)}>
                            <!-- File Input -->
                            <div class="mb-3 shadow bg-secondary rounded p-3">
                                <label
                                    class="form-label"
                                    for="markerFilePicker"
                                    >{m.marker_import_select_file_label()} <i
                                        class="bi bi-info-circle"
                                        aria-label={m.marker_import_supported_formats_label()}
                                    ></i></label
                                >
                                <input
                                    type="file"
                                    class="form-control"
                                    id="markerFilePicker"
                                    onchange={handleFileInput}
                                    accept=".json, .edl, .txt"
                                    aria-describedby="filePickerHelp"
                                />
                                    <div id="filePickerHelp" class="form-text">
                                        {m.marker_import_file_help()}
                                    </div>
                            </div>
                            <div class="row">
                                <!-- Offset by Project Incode Checkbox -->
                                <div class="mb-3 col-12">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            id="offsetTimecode"
                                            bind:checked={offsetTimecode}
                                        />
                                        <label
                                            class="form-check-label"
                                            for="offsetTimecode"
                                            >{m.marker_import_offset_label()}</label>
                                    </div>
                                </div>
                                <!-- Target Event Group Option Start -->
                                <div class="mb-3 col-6">
                                    <label
                                        class="form-label text-warning"
                                        for="markerGroupSelect"
                                        >{m.marker_import_group_label()}</label
                                    >
                                    <select
                                        class="form-select"
                                        id="markerGroupSelect"
                                        bind:value={markerGroup}
                                        aria-describedby="markerGroupHelp"
                                    >
                                        {#each markerState.lists as markerGroupOption}
                                            <option value={markerGroupOption.id}
                                                >{markerGroupOption.name}</option
                                            >
                                        {/each}
                                        <option class="fw-bold" value="new"
                                            >{m.marker_import_new_group_label()}</option
                                        >
                                    </select>
                                    <div id="markerGroupHelp" class="form-text">
                                        {m.marker_import_group_help()}
                                    </div>
                                </div>
                                <!-- Target Event Group Option End -->
                                <!-- Merge or Replace Option Start -->
                                {#if markerGroup !== "new"}
                                    <div class="mb-3 col-6">
                                        <p class="text-warning">
                                            {m.marker_import_merge_replace_label()} <i
                                                class="bi bi-info-circle"
                                                title={m.marker_import_merge_replace_help()}
                                            ></i>
                                        </p>

                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="radio"
                                                bind:group={importOption}
                                                name="importOption"
                                                id="mergeImportOption"
                                                value="merge"
                                                checked
                                            />
                                            <label
                                                class="form-check-label"
                                                for="mergeImportOption"
                                            >
                                                {m.marker_import_merge_label()}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="radio"
                                                bind:group={importOption}
                                                name="importOption"
                                                id="replaceImportOption"
                                                value="replace"
                                            />
                                            <label
                                                class="form-check-label"
                                                for="replaceImportOption"
                                            >
                                                {m.marker_import_replace_label()}
                                            </label>
                                        </div>
                                    </div>
                                {:else}
                                    <!-- Marker Group Name -->
                                    <div class="mb-3 col-12">
                                        <label
                                            class="form-label text-warning"
                                            for="newMarkerGroupName"
                                            >{m.marker_import_new_group_name_label()}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            bind:value={markerGroupName}
                                        />
                                    </div>
                                {/if}
                                <!-- Merge or Replace Option End -->
                            </div>
                        </form>
                        <!-- Import Form End -->
                    </div>
                    <div class="col">
                        <!-- File Preview -->
                        <form id="SourcePreviewForm">
                            <div class="mb-3">
                                <label class="form-label" for="srcPreviewText"
                                    >{m.marker_import_source_preview_label()}</label
                                >
                                <textarea
                                    bind:value={fileContents}
                                    disabled
                                    class="form-control"
                                    id="srcPreviewText"
                                    rows="10"
                                    aria-label={m.marker_import_source_preview_aria()}
                                    placeholder={m.marker_import_source_preview_placeholder()}
                                ></textarea>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    class="btn btn-primary"
                    type="button"
                    id="importMarkersBtn"
                    disabled={fileContents && fileContents.length === 0}
                    aria-label={m.marker_import_action_label()}
                    onclick={() => importMarkers()}>{m.marker_import_action_label()}</button
                >
            </div>
        </div>
    </div>
</div>
